jQuery(document).ready(function () {
  /* Remove Breadcrumb on home and single job */

  if ($(".bannerslider").length > 0) {
    $(".arianne").hide();
  }
  /* Fiches metier | Dropdown */

  function dropdown() {
    $(".fichemetier_dropdown-arrows").click(function () {
      $(this).parent().find(".fichemetier_dropdown-list").slideToggle();
      $(this).find(".fichemetier_dropdown-arrow_disable").toggle();
      $(this).find(".fichemetier_dropdown-arrow_active").toggle();
    });
  }
  dropdown();

  /* Single réalisation circle */

  function circleCalc() {
    var title = $(".singlerealisation_greyBox-cercled-title");
    var width = title.width();
    var height = title.height();
    width = width + 60;
    height = height + 30;
    title.css("width", width);
    title.css("height", height);
  }
  circleCalc();

  /* Fiche offre d'emploi */

  /* Form new button*/
  if ($(".job").length > 0) {
    $(".job_upload_icon").click(function () {
      $(".job_file").click();
    });

    $(".job_upload_result").click(function () {
      $(".job_file").click();
    });

    $(".job_file").change(function () {
      $(".job_upload_result").val($(this).prop("files")[0].name);
    });

    /* Put job id in form */
    var jobId = $(".job_apply").data("job");
    var jobIdInput = $(".job_apply-id");
    jobIdInput.val(jobId);

    /* Put job name in form */
    var jobName = $(".job_mainTitleH1").text();
    var jobNameInput = $(".job_apply-nameJob");
    jobNameInput.val(jobName);

    /* Change spinner  */

    $(".wpcf7-spinner").html("Veuillez patienter<span class='dot'></span><span class='dot'></span><span class='dot'></span>");

    /* Animations */
  }
});
